import cejilChart001 from "./components/cejilChart001";
import CejilChart002 from "./components/CejilChart002";
import cejilHero from "./components/cejilHero";

export default {
  cejilChart001,
  CejilChart002,
  cejilHero
};